import { render, staticRenderFns } from "./OTPTimer.vue?vue&type=template&id=75c9714d&scoped=true"
import script from "./OTPTimer.vue?vue&type=script&lang=js"
export * from "./OTPTimer.vue?vue&type=script&lang=js"
import style0 from "./OTPTimer.vue?vue&type=style&index=0&id=75c9714d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c9714d",
  null
  
)

export default component.exports